import styled, { css } from 'styled-components';

export const Container = styled.div(
  ({ theme }) => css`
    display: none;

    @media (max-width: ${theme.sz.lg}) {
      display: grid;
      background: ${theme.co.primary90};
      border-radius: 14px;
      padding: ${theme.sz.s4};
      grid-template-columns: 44px 1fr;
      gap: ${theme.sz.s3};
      margin-top: ${theme.sz.s5};
    }
  `,
);

export const Avatar = styled.div(
  ({ theme }) => css`
    width: 44px;
    height: 44px;
    background: ${theme.co.warning30};
    border-radius: 50%;
    color: #fff;
    font-weight: 800;
    font-size: 1.125rem;
    display: grid;
    place-items: center;
  `,
);

export const QuoteText = styled.p(
  ({ theme }) => css`
    font-size: 0.9375rem;
    color: ${theme.co.secondary20};
    line-height: 1.4;
    font-weight: 500;
    margin: 0 0 ${theme.sz.s2};
  `,
);

export const Stars = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: 2px;
    color: ${theme.co.primary20};

    svg {
      width: 16px;
      height: 16px;
    }
  `,
);

export const Author = styled.div(
  ({ theme }) => css`
    font-size: 0.8125rem;
    color: ${theme.co.secondary50};
    font-weight: 600;
    margin-top: 4px;
  `,
);
